import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Email as EmailIcon, GitHub as GitHubIcon, LinkedIn as LinkedInIcon } from '@mui/icons-material';

const ProfileSection: React.FC = () => {
  return (
    <Box sx={{ 
      width: { xs: '100%', md: '350px' }, 
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: { xs: 'flex-start', md: 'center' },
    }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 4 }, // Padding réduit sur mobile
          background: 'rgba(30, 41, 59, 0.6)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(37, 99, 235, 0.15)',
          borderRadius: 3,
          textAlign: 'center',
        }}
      >
        {/* Avatar ou logo */}
        <Box
          sx={{
            width: { xs: 100, md: 120 }, // Plus petit sur mobile
            height: { xs: 100, md: 120 },
            borderRadius: '50%',
            margin: { xs: '0 auto 16px', md: '0 auto 24px' }, // Moins d'espace sur mobile
            boxShadow: '0 8px 32px rgba(167, 139, 250, 0.3)',
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            padding: '3px',
          }}
        >
          <img
            src="/profilepicture.jpg"
            alt="Ordrinn"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
          />
        </Box>

        {/* Nom et titre */}
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold',
            mb: 1,
            fontSize: { xs: '2rem', md: '3rem' }, // Plus petit sur mobile
          }}
        >
          Ordrinn
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: 'text.secondary',
            mb: { xs: 2, md: 3 }, // Moins d'espace sur mobile
            fontWeight: 500,
            fontSize: { xs: '1.1rem', md: '1.25rem' },
          }}
        >
          Développeur Full Stack
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            color: 'text.primary',
            mb: { xs: 3, md: 4 }, // Moins d'espace sur mobile
            lineHeight: 1.6,
            fontSize: { xs: '0.95rem', md: '1rem' },
          }}
        >
          Spécialisé dans le développement d'applications interactives pour le broadcast. 
          Expert en intégration hardware/software et solutions temps réel.
        </Typography>

        {/* Boutons d'action */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<EmailIcon />}
            component="a"
            href="mailto:contact@ordrinn.dev"
            sx={{
              background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #8b5cf6 0%, #0f766e 100%)',
                transform: 'translateY(-2px)',
              },
              borderRadius: 2,
              py: 1.5,
              fontWeight: 600,
              transition: 'all 0.3s ease',
            }}
          >
            Me contacter
          </Button>
          
          {/* Adresse email alternative */}
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'text.secondary', 
              fontSize: '0.8rem',
              textAlign: 'center',
              mt: 1,
              opacity: 0.8
            }}
          >
            contact@ordrinn.dev
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default ProfileSection;
